import styled from 'styled-components'
import variables from '../../styles/variables'

// Common Panel Title
export const PanelTitle = styled.h3`
  font-size: 1.5rem;
  font-weight: 600;
  text-align: center;
  margin-bottom: 2rem;
  color: ${variables.colors.charcoal};
  word-spacing: normal;
  
  @media (max-width: 768px) {
    font-size: 1.3rem;
    margin-bottom: 1.5rem;
  }
`

// Hardware Note
export const HardwareNote = styled.p`
  font-size: 0.85rem;
  color: #666;
  text-align: center;
  margin-top: 1.5rem;
  font-style: italic;
  
  @media (max-width: 768px) {
    font-size: 0.8rem;
    margin-top: 1rem;
  }
`

// Standard Variant (4-card grid)
export const StandardPanel = styled.div`
  background: white;
  border: 2px solid #e9ecef;
  border-radius: 12px;
  padding: 2.5rem 2rem;
  box-shadow: 0 4px 15px rgba(0,0,0,0.08);
  
  @media (max-width: 768px) {
    padding: 1.5rem 1rem;
  }
`

export const MetricsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 2rem;
  
  @media (max-width: 768px) {
    grid-template-columns: repeat(2, 1fr);
    gap: 1.5rem;
  }
  
  @media (max-width: 480px) {
    grid-template-columns: 1fr;
    gap: 1rem;
  }
`

export const MetricCard = styled.div`
  text-align: center;
  padding: 1.5rem 1rem;
  border: 1px solid #f0f0f0;
  border-radius: 8px;
  transition: all 0.3s ease;
  
  &:hover {
    border-color: ${variables.colors.primary};
    transform: translateY(-2px);
    box-shadow: 0 5px 15px rgba(0,0,0,0.1);
  }
`

export const MetricValue = styled.div`
  font-size: 2rem;
  font-weight: 700;
  color: ${variables.colors.primary};
  margin-bottom: 0.5rem;
  line-height: 1.2;
  
  @media (max-width: 768px) {
    font-size: 1.7rem;
  }
`

export const MetricLabel = styled.div`
  font-size: 1rem;
  font-weight: 600;
  color: ${variables.colors.charcoal};
  margin-bottom: 0.25rem;
`

export const MetricNote = styled.div`
  font-size: 0.85rem;
  color: #666;
  line-height: 1.3;
`

// Compact Variant (horizontal row)
export const CompactPanel = styled.div`
  background: #f8f9fa;
  border-radius: 8px;
  padding: 1.5rem;
  margin: 1rem 0;
`

export const MetricsRow = styled.div`
  display: flex;
  justify-content: space-around;
  align-items: center;
  gap: 2rem;
  
  @media (max-width: 768px) {
    flex-direction: column;
    gap: 1rem;
  }
`

export const CompactMetric = styled.div`
  text-align: center;
  min-width: 120px;
`

export const CompactValue = styled.div`
  font-size: 1.5rem;
  font-weight: 700;
  color: ${variables.colors.primary};
  margin-bottom: 0.25rem;
  
  @media (max-width: 768px) {
    font-size: 1.3rem;
  }
`

export const CompactLabel = styled.div`
  font-size: 0.9rem;
  font-weight: 500;
  color: #555;
`

// Detailed Variant (comprehensive grid)
export const DetailedPanel = styled.div`
  background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
  border: 2px solid #dee2e6;
  border-radius: 16px;
  padding: 3rem 2.5rem;
  box-shadow: 0 8px 25px rgba(0,0,0,0.1);
  
  @media (max-width: 768px) {
    padding: 2rem 1.5rem;
  }
`

export const DetailedMetricsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 2.5rem;
  margin-bottom: 2rem;
  
  @media (max-width: 768px) {
    grid-template-columns: 1fr;
    gap: 2rem;
  }
`

export const DetailedMetric = styled.div`
  background: white;
  border: 1px solid #e9ecef;
  border-radius: 12px;
  padding: 2rem;
  text-align: center;
  transition: all 0.3s ease;
  
  &:hover {
    border-color: ${variables.colors.primary};
    transform: translateY(-3px);
    box-shadow: 0 10px 30px rgba(0,0,0,0.15);
  }
`

export const MetricHeader = styled.h4`
  font-size: 1.1rem;
  font-weight: 600;
  color: ${variables.colors.charcoal};
  margin-bottom: 1rem;
  word-spacing: normal;
`

export const MetricDetail = styled.div`
  font-size: 0.9rem;
  color: #666;
  margin-bottom: 0.75rem;
  font-weight: 500;
`

export const MetricDescription = styled.p`
  font-size: 0.85rem;
  color: #888;
  margin: 0;
  line-height: 1.4;
`